import { useSelector } from 'react-redux'
import { WifiBestPracticesInitial } from './components'
import { WIFI_BEST_PRACTICES_STAGES } from './constants'

function stages() {
  return {
    [WIFI_BEST_PRACTICES_STAGES.INITIAL]: <WifiBestPracticesInitial />,
  }
}

export function WifiBestPracticesDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages()[stage]
}
